import { motion } from "framer-motion";

export const LinkedinIcon = () => {
  return (
    <motion.svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="100%"
      viewBox="0 0 640 640"
      enableBackground="new 0 0 640 640"
      className="home-social-icon"
      whileHover={{ scale: 1.15 }}
    >
      <motion.path
        className="link-icon"
        fill="#777777"
        whileHover={{ fill: "#373737ff" }}
        opacity="1.000000"
        stroke="none"
        d="
M0.999996,607.000000 
	C1.000000,416.640839 1.000000,226.281677 1.346032,35.669914 
	C2.354286,34.501278 3.266460,33.676983 3.641381,32.655495 
	C9.631970,16.333878 21.174088,6.525991 38.131897,2.915916 
	C38.857662,2.761411 39.381889,1.660196 40.000000,1.000000 
	C226.692505,1.000000 413.385010,1.000000 600.393555,1.395809 
	C601.053711,2.128673 601.359131,2.705512 601.747620,2.768325 
	C619.860291,5.696742 632.013977,15.828711 638.529724,32.925320 
	C638.864319,33.803192 640.154663,34.316799 641.000000,34.999992 
	C641.000000,225.359177 641.000000,415.718353 640.664917,606.317566 
	C639.587646,607.608459 638.596436,608.561768 638.140930,609.724792 
	C631.763184,626.011658 619.931763,635.662354 602.847900,639.085876 
	C602.132812,639.229248 601.611572,640.339966 601.000000,641.000000 
	C414.640839,641.000000 228.281677,641.000000 41.614899,640.610657 
	C40.477367,639.817627 39.687744,639.226624 38.811523,639.038086 
	C23.838741,635.815552 12.381176,628.106323 5.830077,613.805237 
	C4.691941,611.320679 2.633419,609.257690 0.999996,607.000000 
M289.500214,241.310028 
	C276.725281,241.310028 263.950348,241.310028 251.051788,241.310028 
	C251.051788,342.758728 251.051788,443.505585 251.051788,544.533447 
	C282.224091,544.533447 313.122101,544.533447 344.654480,544.533447 
	C344.654480,542.365601 344.654480,540.417175 344.654480,538.468750 
	C344.654480,490.476898 344.518860,442.484344 344.762604,394.493744 
	C344.814850,384.209534 345.590759,373.830017 347.187317,363.675842 
	C349.569763,348.523865 355.132233,334.683868 368.448730,325.494873 
	C380.154755,317.417114 393.469757,315.990906 407.199341,316.896698 
	C426.183380,318.149170 438.855011,327.814270 445.134918,345.796692 
	C449.991455,359.703247 450.724701,374.176514 450.746857,388.695953 
	C450.823151,438.687378 450.776855,488.678955 450.777222,538.670471 
	C450.777222,540.590759 450.777161,542.511108 450.777161,544.530640 
	C482.625885,544.530640 513.706848,544.530640 545.067932,544.530640 
	C545.158508,542.800171 545.302856,541.336914 545.301941,539.873840 
	C545.267944,482.718079 545.363892,425.561707 545.108276,368.406891 
	C544.998352,343.838470 542.654846,319.501007 534.290833,296.115082 
	C523.712585,266.538208 503.615875,247.187088 473.076202,238.989594 
	C456.000610,234.406158 438.586823,232.769836 421.075714,234.543579 
	C387.883881,237.905685 361.095490,252.350296 343.354889,281.529510 
	C343.004974,282.105072 342.291779,282.459747 340.897736,283.633331 
	C340.897736,269.045227 340.897736,255.500229 340.897736,241.310043 
	C323.725983,241.310043 307.113129,241.310043 289.500214,241.310028 
M191.223907,338.500122 
	C191.223907,306.255005 191.223907,274.009918 191.223907,241.780945 
	C159.456741,241.780945 128.438766,241.780945 97.543106,241.780945 
	C97.543106,342.974030 97.543106,443.694366 97.543106,544.546387 
	C128.816162,544.546387 159.729950,544.546387 191.223923,544.546387 
	C191.223923,476.019043 191.223923,407.759613 191.223907,338.500122 
M129.715424,197.961761 
	C130.361176,198.122925 131.004639,198.294022 131.653015,198.443817 
	C158.427155,204.629898 185.307632,190.682495 195.469162,165.333481 
	C205.425568,140.496170 195.622604,111.882401 172.437119,98.105423 
	C149.057220,84.212921 119.501358,89.285301 102.103088,110.520927 
	C78.157211,139.748306 90.045097,185.700089 129.715424,197.961761 
z"
      />

      <path
        fill="none"
        opacity="1.000000"
        stroke="none"
        d="
M290.000244,241.310028 
	C307.113129,241.310043 323.725983,241.310043 340.897736,241.310043 
	C340.897736,255.500229 340.897736,269.045227 340.897736,283.633331 
	C342.291779,282.459747 343.004974,282.105072 343.354889,281.529510 
	C361.095490,252.350296 387.883881,237.905685 421.075714,234.543579 
	C438.586823,232.769836 456.000610,234.406158 473.076202,238.989594 
	C503.615875,247.187088 523.712585,266.538208 534.290833,296.115082 
	C542.654846,319.501007 544.998352,343.838470 545.108276,368.406891 
	C545.363892,425.561707 545.267944,482.718079 545.301941,539.873840 
	C545.302856,541.336914 545.158508,542.800171 545.067932,544.530640 
	C513.706848,544.530640 482.625885,544.530640 450.777161,544.530640 
	C450.777161,542.511108 450.777222,540.590759 450.777222,538.670471 
	C450.776855,488.678955 450.823151,438.687378 450.746857,388.695953 
	C450.724701,374.176514 449.991455,359.703247 445.134918,345.796692 
	C438.855011,327.814270 426.183380,318.149170 407.199341,316.896698 
	C393.469757,315.990906 380.154755,317.417114 368.448730,325.494873 
	C355.132233,334.683868 349.569763,348.523865 347.187317,363.675842 
	C345.590759,373.830017 344.814850,384.209534 344.762604,394.493744 
	C344.518860,442.484344 344.654480,490.476898 344.654480,538.468750 
	C344.654480,540.417175 344.654480,542.365601 344.654480,544.533447 
	C313.122101,544.533447 282.224091,544.533447 251.051788,544.533447 
	C251.051788,443.505585 251.051788,342.758728 251.051788,241.310028 
	C263.950348,241.310028 276.725281,241.310028 290.000244,241.310028 
z"
      />
      <path
        fill="none"
        opacity="1.000000"
        stroke="none"
        d="
M191.223907,339.000122 
	C191.223923,407.759613 191.223923,476.019043 191.223923,544.546387 
	C159.729950,544.546387 128.816162,544.546387 97.543106,544.546387 
	C97.543106,443.694366 97.543106,342.974030 97.543106,241.780945 
	C128.438766,241.780945 159.456741,241.780945 191.223907,241.780945 
	C191.223907,274.009918 191.223907,306.255005 191.223907,339.000122 
z"
      />
      <path
        fill="none"
        opacity="1.000000"
        stroke="none"
        d="
M129.324036,197.857788 
	C90.045097,185.700089 78.157211,139.748306 102.103088,110.520927 
	C119.501358,89.285301 149.057220,84.212921 172.437119,98.105423 
	C195.622604,111.882401 205.425568,140.496170 195.469162,165.333481 
	C185.307632,190.682495 158.427155,204.629898 131.653015,198.443817 
	C131.004639,198.294022 130.361176,198.122925 129.324036,197.857788 
z"
      />
    </motion.svg>
  );
};
